import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Material components
import {
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Checkbox,
} from '@material-ui/core';

import { formatGenerali } from './../../../utils/info-moduli';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        borderRadius: '4px',
        padding: '0px',
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
    minWidth: {
        minWidth: '100%',
    },
    red: {
        backgroundColor: '#d9534f52',
        paddingTop: '0px',
        paddingBottom: '0px',
        '&:hover': {
            backgroundColor: '#ca535085',
        },
    },
    green: {
        backgroundColor: '#00ff0024',
        paddingTop: '0px',
        paddingBottom: '0px',
        '&:hover': {
            backgroundColor: '#00c50069',
        },
    },
    divider: {
        borderTop: '1px solid #00000021'
    },
});


class ModuliGenerali extends Component {
    constructor(props) {
        super(props);

        this.setupChange = this.setupChange.bind(this);
    }

    setupChange(keyName, newValue) {
        if(!this.props.isReadOnly)
            this.props.handleChangeFieldModulo('Generali', keyName, newValue);
    }

    render() {
        const { classes, generali } = this.props;

        return (
            <List className={classes.root}>


                {
                    Object.keys(generali).map((keyName, i) => {
                        const labelId = `checkbox-list-label-${keyName}`;

                        return (
                            <ListItem className={`${generali[keyName] === true ? classes.green : classes.red} ${keyName !== 'DocumentiDigitali' ? classes.divider : null}`}
                                key={keyName}
                                role={undefined}
                                dense
                                button
                                onClick={e => { this.setupChange(keyName, !generali[keyName]) }}
                            >
                                <ListItemIcon >
                                    <Checkbox
                                        edge="start"
                                        checked={generali[keyName]}
                                        tabIndex={-1}
                                        disableRipple
                                        inputProps={{ 'aria-labelledby': labelId }}
                                    />
                                </ListItemIcon>
                                <ListItemText id={labelId} primary={formatGenerali(keyName)} />
                            </ListItem>
                        );
                    })

                }

            </List>

        );

    }
}

ModuliGenerali.propTypes = {
    generali: PropTypes.shape({}).isRequired,
    handleChangeFieldModulo: PropTypes.func.isRequired,

    isReadOnly: PropTypes.bool.isRequired
};

export default withStyles(styles)(ModuliGenerali);